module.exports = __webpack_public_path__ + "img/shang4.2ca09cc4.png";